/** 모바일 — 이번 달 손익 요약 + 확인할 것(재고 부족, 잔여 임박 회원권) */
import React, { useMemo, useState } from 'react';
import { monthlyPnl, thisYm, stockSummary, loadTable, passRemain, fmt } from 'shop/shopStore';
import { Page, H, CardBox, Grid2, Btn, Hero } from './mobileUi';

const shiftYm = (ym, d) => {
  const dt = new Date(Number(ym.slice(0, 4)), Number(ym.slice(4)) - 1 + d, 1);
  return `${dt.getFullYear()}${String(dt.getMonth() + 1).padStart(2, '0')}`;
};

const MobileHome = ({ tc }) => {
  const [ym, setYm] = useState(thisYm());
  const pnl = useMemo(() => monthlyPnl(tc, ym), [tc, ym]);
  const low = useMemo(() => stockSummary(tc).filter((s) => s.lowStock && s.useYn !== 'N'), [tc]);
  const soon = useMemo(
    () => loadTable(tc, 'pass').filter((p) => p.status === 'ACTIVE' && passRemain(p) <= 2).length,
    [tc]
  );

  return (
    <Page>
      <H>손익 요약</H>
      <Grid2>
        <Btn onClick={() => setYm(shiftYm(ym, -1))}>‹ 이전 달</Btn>
        <Btn onClick={() => setYm(shiftYm(ym, 1))}>다음 달 ›</Btn>
      </Grid2>
      <div style={{ textAlign: 'center', fontFamily: "'Didot','Bodoni MT',Georgia,serif", fontSize: 18, letterSpacing: '0.08em' }}>{ym.slice(0, 4)}년 {ym.slice(4)}월</div>
      <Hero>
        <span className="k">Operating Profit · 영업이익</span>
        <span className={`v ${pnl.operatingProfit < 0 ? 'neg' : ''}`}>₩{fmt(pnl.operatingProfit)}</span>
        <span className="sub">매출 − 원가 − 재고손실 − 고정비</span>
      </Hero>
      <Grid2>
        <CardBox><span className="lab">매출</span><span className="n">₩{fmt(pnl.revenue)}</span><span className="s">{pnl.saleCount}건</span></CardBox>
        <CardBox><span className="lab">매출원가</span><span className="n">₩{fmt(pnl.cogs)}</span></CardBox>
        <CardBox><span className="lab">월 고정비</span><span className="n">₩{fmt(pnl.expense)}</span></CardBox>
        <CardBox><span className="lab">시술</span><span className="n">{pnl.recordCount}건</span></CardBox>
      </Grid2>
      {low.length > 0 && (
        <CardBox $warn>
          <span className="t">안전재고 미달 {low.length}개</span>
          <span className="s">{low.map((s) => s.productNm).join(', ')}</span>
        </CardBox>
      )}
      {soon > 0 && (
        <CardBox $warn>
          <span className="t">잔여 2회 이하 회원권 {soon}건</span>
          <span className="s">회원권 탭에서 확인하세요</span>
        </CardBox>
      )}
    </Page>
  );
};

export default MobileHome;
